import {EventOrder, OrderLookProduct} from '../../types/eventData'
import {OrderItemsListProps, OrderLookProductById, OrderItemKitsById} from './types'

const getMatchingOrderItems = (orderItem: OrderLookProduct, eventOrder: EventOrder) =>
  orderItem.userEventLookItem &&
  (orderItem.product.category === 'jackets' || orderItem.product.category === 'pants')
    ? eventOrder.orderLookProducts.filter(
        (item) => item.userEventLookItem === orderItem.userEventLookItem,
      )
    : null

export const onOrderItemClick = (
  orderItem: OrderLookProduct,
  selectedItems: OrderLookProductById,
  setSelectedItems: React.Dispatch<React.SetStateAction<OrderLookProductById>>,
  userOrderItemClick: OrderItemsListProps['userOrderItemClick'],
  orderItemKitsById: OrderItemKitsById,
) => {
  const itemId = orderItem.id
  const matchingOrderItemKits = orderItemKitsById[itemId]
  const selectedItemsCopy = {...selectedItems}

  const deleteOrderItem = (item: OrderLookProduct): void => {
    delete selectedItemsCopy[item.id]
  }
  const addOrderItem = (item: OrderLookProduct): void => {
    selectedItemsCopy[item.id] = item
  }

  if (selectedItemsCopy[itemId]) {
    deleteOrderItem(orderItem)
    if (matchingOrderItemKits) matchingOrderItemKits?.forEach((item) => deleteOrderItem(item))
  } else {
    addOrderItem(orderItem)
    if (matchingOrderItemKits) matchingOrderItemKits?.forEach((item) => addOrderItem(item))
  }

  setSelectedItems(selectedItemsCopy)
  if (userOrderItemClick) userOrderItemClick(selectedItemsCopy)
}

export const getOrderItemKitsById = (eventOrder: EventOrder) =>
  eventOrder.orderLookProducts.reduce((orderItemKits: OrderItemKitsById, orderLookProduct) => {
    const matchingOrderItems = getMatchingOrderItems(orderLookProduct, eventOrder)
    // eslint-disable-next-line
    if (matchingOrderItems) orderItemKits[orderLookProduct.id] = matchingOrderItems
    return orderItemKits
  }, {})

export const getAllOrderItemsById = (eventOrder: EventOrder) =>
  eventOrder.orderLookProducts.reduce(
    (orderItemsById: OrderLookProductById, orderLookProduct: OrderLookProduct) => {
      const orderItemsByIdCopy = {...orderItemsById}
      orderItemsByIdCopy[orderLookProduct.id] = orderLookProduct
      return orderItemsByIdCopy
    },
    {},
  )
